import * as types from "./types";

// Pages
const fetchPagesRequest = (bool) => ({
   type: types.FETCH_PAGES_REQUEST,
   payload: bool,
});

const fetchPagesCompleted = (pages, globalSettings) => ({
   type: types.FETCH_PAGES_COMPLETED,
   payload: { pages, globalSettings },
})
const getPageByIdRequest = (bool) => ({
   type: types.FETCH_PAGE_BY_ID_REQUEST,
   payload: bool,
});

const getPageByIdCompleted = (data, leftFetching) => ({
   type: types.FETCH_PAGE_BY_ID_COMPLETED,
   payload: { data, leftFetching },
})

const createPageCompleted = (data) => ({
   type: types.CREATE_PAGE_COMPLETED,
   payload: data,
})


const deletePageCompleted = (id, isDeleted) => ({
   type: types.DELETE_PAGE_COMPLETED,
   payload: { id, isDeleted },
})
const toggleVisibilityPageCompleted = (id) => ({
   type: types.TOGGLE_VISIBILITY_PAGE_COMPLETED,
   payload: id,
})

const fetchPageDifferentAccessCompleted = (data) => ({
   type: types.FETCH_PAGE_DIFFERENT_ACCESS_COMPLETED,
   payload: data,
})
const publishDraftContentRequest = (bool) => ({
   type: types.PUBLISH_DRAFT_CONTENT_REQUEST,
   payload: bool,
})
const updatePageCompleted = (id, data) => ({
   type: types.UPDATE_PAGE_COMPLETED,
   payload: { id, data },
})

const setCurrentPage = (data, sectionUuid) => ({
   type: types.SET_CURRENT_PAGE,
   payload: { data, sectionUuid },
})
const fetchSaveAsDraftRequest = (data) => ({
   type: types.FETCH_SAVE_AS_DRAFT_REQUEST,
   payload: data,
})
const updatePageSectionsCompleted = (uuid, data, isMeta = false) => ({
   type: types.UPDATE_PAGE_SECTIONS_COMPLETED,
   payload: { uuid, data, isMeta },
})
const updateCurrentSectionCompleted = (uuid) => ({
   type: types.UPDATE_CURRENT_SECTION_UUID_COMPLETED,
   payload: uuid,
})
const stateUpdateAction = (data) => ({
   type: types.STATE_UPDATE_ACTION,
   payload: data,
})
const deleteSectionCompleted = (id, isDeleted, sectionUuid) => ({
   type: types.DELETE_SECTION_COMPLETED,
   payload: { id, isDeleted, sectionUuid },
})
const toggleVisibilitySectionCompleted = (id, sectionUuid) => ({
   type: types.TOGGLE_VISIBILITY_SECTIONS_COMPLETED,
   payload: { id, sectionUuid },
})
const updateGlobalSettingsCompleted = (type, data, bool = false) => ({
   type: types.UPDATE_GLOBAL_SETTINGS_COMPLETED,
   payload: { type, data, bool },
})
const restorGlobalSettingsAction = () => ({
   type: types.RESTOR_GLOBAL_SETTINGS_ACTION,
})
const restorCurrenPageAction = () => ({
   type: types.RESTOR_CURRENT_PAGE_ACTION,
})
const restorPageSectionsAction = () => ({
   type: types.RESTOR_PAGE_SECTIONS_ACTION,
})
const setCurrentSegmentAction = (data) => ({
   type: types.SET_CURRENT_SEGMENT_ACTION,
   payload: data,
})
const setUpdateContentResources = (data) => ({
   type: types.SET_UPDATE_CONTENT_RESOURCES,
   payload: data,
})
const updatePageSectionsOrder = (data) => ({
   type: types.UPDATE_PAGE_SECTIONS_ORDER,
   payload: data,
})
const setPrepearComponentForRender = (data) => ({
   type: types.SET_PREPEAR_COMPONENT_FOR_RENDER,
   payload: data,
})

export {
   // Pages
   fetchPagesRequest,
   fetchPagesCompleted,
   getPageByIdRequest,
   getPageByIdCompleted,
   createPageCompleted,
   deletePageCompleted,
   toggleVisibilityPageCompleted,
   fetchPageDifferentAccessCompleted,
   publishDraftContentRequest,
   updatePageCompleted,
   setCurrentPage,
   fetchSaveAsDraftRequest,
   updatePageSectionsCompleted,
   updateCurrentSectionCompleted,
   stateUpdateAction,
   deleteSectionCompleted,
   toggleVisibilitySectionCompleted,
   updateGlobalSettingsCompleted,
   restorGlobalSettingsAction,
   setCurrentSegmentAction,
   setUpdateContentResources,
   updatePageSectionsOrder,
   restorCurrenPageAction,
   restorPageSectionsAction,
   setPrepearComponentForRender,
};
